import { LabelResource, SearchResult } from "@search/api/types";
import { Filters } from "@search/store/types";
import { useEffect } from "react";

import { gaViewItemList } from "@/utils/tracking";

function useGaViewItemList(
  searchResults: SearchResult[],
  filters: Filters,
  nameResources: LabelResource,
) {
  // Track GA4 ecommerce view_item_list event when results are loaded
  useEffect(() => {
    if (searchResults.length > 0) {
      const formattedItems = searchResults.map((result) => ({
        affiliation: "",
        itemId: result.venueId.toString(),
        itemName: result.venueName,
        price: result.price,
        quantity: 1,
      }));

      gaViewItemList({
        item_list_id: filters.regionIds[0] || "",
        item_list_name: nameResources[filters.regionIds[0]] || "All regions",
        items: formattedItems,
      });
    }
  }, [searchResults, filters, nameResources]);
}

export { useGaViewItemList };
